<template>
  <div class="has-campaignCuration-component">
    <div class="column is-8 is-offset-2">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-3 has-text-centered has-text-grey-dark dm-sans">
            Gostaria de ter uma consultoria mensal para acompanhar suas campanhas de WhatsApp?*
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-full">
          <div class="buttons is-flex is-justify-content-center is-full">
            <button
                class="button is-grey is-size-3 has-text-weight-bold mx-4 is-one-quarter"
                @click.prevent="selectCuration()"
            >
              Sim
            </button>
            <button
                class="button is-grey is-size-3 has-text-weight-bold mx-4 is-one-quarter"
                @click.prevent="selectNoCuration()"
            >
              Não
            </button>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-4 has-text-centered has-text-grey-dark dm-sans mt-6">
            * Esse serviço é opcional e tem custo de R$ {{ formatPrice(campaignCuration.price) }} por mês
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import campaignCurationsApi from '@/apis/campaignCurations'

export default {

  name: 'campaign-curation',

  data() {
    return {
      campaignCuration: {}
    }
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  watch: {
    'formData.plan': {
      handler() {
        this.getCampaignCuration()
      },
      deep: true
    }
  },

  methods: {
    cleanData() {
      this.formData.campaignCuration.data = {}
    },
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },
    selectCuration() {
      this.formData.campaignCuration.showStep = true
      this.formData.campaignCuration.data = this.campaignCuration
      this.$emit('nextTab')
    },
    selectNoCuration() {
      this.formData.campaignCuration.showStep = false
      this.formData.campaignCuration.data = {}
      this.$emit('nextTab')
    },
    async getCampaignCuration() {
      if (this.formData.plan.data.id) {
        this.campaignCuration = await campaignCurationsApi.get({
          plan_id: this.formData.plan.data.id
        })
      }
    }
  },

  mounted() {
    this.getCampaignCuration()
  }

}

</script>
